import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from './actions'

export default ({ name, perPage = 5, maxPageButtons = 3 }) => ComposedComponent => {

  const mapStateToProps = (state) => ({
    paginator: state.paginator,
  })

  const mapDispatchToActions = {
    ...actions,
  }

  class Paginator extends Component {

    static propTypes = {
      initialize: PropTypes.func,
      paginator: PropTypes.object,
      loadPage: PropTypes.func,
      nextPage: PropTypes.func,
      prevPage: PropTypes.func,
      gotoPage: PropTypes.func,
    }

    componentDidMount () {
      const loadPage = (...args) => this._comp.loadPaginatorPage(...args)
      this.props.initialize({ name, perPage, loadPage, maxPageButtons })
      this.props.loadPage(name)
    }

    nextPage = () => {
      return this.props.nextPage(name)
    }

    prevPage = () => {
      return this.props.prevPage(name)
    }

    gotoPage = (n) => {
      return this.props.gotoPage(name, n)
    }

    loadPage = () => {
      return this.props.loadPage(name)
    }

    render () {
      const state = this.props.paginator[name]
      const currentPagination = {
        ...state,
        nextPage: this.nextPage,
        prevPage: this.prevPage,
        gotoPage: this.gotoPage,
        loadPage: this.loadPage,
      }

      return (
        <ComposedComponent
          {...this.props}
          ref={(comp) => { this._comp = comp }}
          paginator={currentPagination}
        />
      )
    }

  }

  return connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(Paginator)

}



// WEBPACK FOOTER //
// ./src/services/paginator/paginator.js